// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20_Sw","colBig":"styles_colBig__355DE","colSmall":"styles_colSmall__10scB"};